import { useQuery } from '@tanstack/react-query'
import { listAdminCategories } from '@/lib/domain/categories'
import { adminQueryKeys } from '@/lib/query-keys'

export function useCategories() {
  return useQuery({
    queryKey: adminQueryKeys.categoriesList(),
    queryFn: async () => {
      const result = await listAdminCategories()
      return result.items
    },
    staleTime: 10 * 60 * 1000, // categories are stable
  })
}
